import * as React from "react";

import { PiletApi } from "opencak-app";

import { isNullable } from "@cak-legacy/core-utils";

export const PiletApiContext = React.createContext<PiletApi | null>(null);

export const usePiletApiContext = () => {
  const context = React.useContext(PiletApiContext);

  if (isNullable(context)) {
    throw new Error("usePiletApiContext must be used within a PiletApiContextProvider");
  }

  return context;
};

export const PiletApiContextProvider = (props: React.ProviderProps<PiletApi>) => {
  return <PiletApiContext.Provider value={props.value}>{props.children}</PiletApiContext.Provider>;
};
